// extracted by mini-css-extract-plugin
export default {"share-list":"ShareUrlViaSocial_share-list__R4SNU","share-list__item":"ShareUrlViaSocial_share-list__item__X7y82"};